// Travel gallery data.
//
// Sources data from src/galleryManifest.json (generated by `npm run gallery:build`).
// While the manifest is empty (no real photos uploaded yet), falls back to the
// Unsplash placeholder set defined below so the UI still renders during development.

import manifest from './galleryManifest.json';

// ─── Placeholder fallback (used until you run gallery:build) ────────────

const placeholderCountries = [
  {
    slug: 'italy',
    name: 'Italy',
    flag: '🇮🇹',
    cities: ['Rome', 'Florence'],
    period: 'Dec 2025',
    cover:
      'https://images.unsplash.com/photo-1525874684015-58379d421a52?auto=format&fit=crop&w=1400&q=75',
    intro:
      'Three weeks chasing renaissance light. Sunrise over the Tiber, espresso at every corner.',
    featured: {
      src: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?auto=format&fit=crop&w=1800&q=80',
      caption: 'Colosseum at golden hour — the city stops breathing for a minute.',
    },
  },
  {
    slug: 'spain',
    name: 'Spain',
    flag: '🇪🇸',
    cities: ['Barcelona', 'Madrid'],
    period: 'Jan 2026',
    cover:
      'https://images.unsplash.com/photo-1583422409516-2895a77efded?auto=format&fit=crop&w=1400&q=75',
    intro: 'Gaudí mornings, tapas nights, and metro maps memorised in two days.',
    featured: {
      src: 'https://images.unsplash.com/photo-1539037116277-4db20889f2d4?auto=format&fit=crop&w=1800&q=80',
      caption: 'Park Güell — mosaics, mountains, and a horizon that pulls you forward.',
    },
  },
  {
    slug: 'japan',
    name: 'Japan',
    flag: '🇯🇵',
    cities: ['Tokyo', 'Kyoto', 'Osaka'],
    period: 'Feb 2026',
    cover:
      'https://images.unsplash.com/photo-1542051841857-5f90071e7989?auto=format&fit=crop&w=1400&q=75',
    intro:
      'Two weeks of neon, shrines, ramen, and bullet trains. The country that turns every street into a frame.',
    featured: {
      src: 'https://images.unsplash.com/photo-1493780474015-ba834fd0ce2f?auto=format&fit=crop&w=1800&q=80',
      caption: 'Fushimi Inari before sunrise — silence between the gates.',
    },
  },
  {
    slug: 'portugal',
    name: 'Portugal',
    flag: '🇵🇹',
    cities: ['Lisbon', 'Porto'],
    period: 'Mar 2026',
    cover:
      'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?auto=format&fit=crop&w=1400&q=75',
    intro: 'Tiled facades, tram bells, and the cleanest ocean light I have seen this year.',
    featured: {
      src: 'https://images.unsplash.com/photo-1513735492246-483525079686?auto=format&fit=crop&w=1800&q=80',
      caption: 'Alfama rooftops — Lisbon waking up slowly.',
    },
  },
  {
    slug: 'greece',
    name: 'Greece',
    flag: '🇬🇷',
    cities: ['Athens', 'Santorini'],
    period: 'Apr 2026',
    cover:
      'https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=1400&q=75',
    intro: 'Ruins in the morning, blue domes in the afternoon, the Aegean for dinner.',
    featured: {
      src: 'https://images.unsplash.com/photo-1530841377377-3ff06c0ca713?auto=format&fit=crop&w=1800&q=80',
      caption: 'Oia at dusk — every window facing the same horizon.',
    },
  },
  {
    slug: 'morocco',
    name: 'Morocco',
    flag: '🇲🇦',
    cities: ['Marrakech', 'Chefchaouen'],
    period: 'May 2026',
    cover:
      'https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=1400&q=75',
    intro: 'Spice markets, blue alleys, and a tea ceremony that lasts longer than your patience.',
    featured: {
      src: 'https://images.unsplash.com/photo-1539020140153-e479b8c5b9c5?auto=format&fit=crop&w=1800&q=80',
      caption: 'Chefchaouen — the city that paints itself every morning.',
    },
  },
  {
    slug: 'turkey',
    name: 'Türkiye',
    flag: '🇹🇷',
    cities: ['Istanbul', 'Cappadocia'],
    period: 'May 2026',
    cover:
      'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?auto=format&fit=crop&w=1400&q=75',
    intro: 'Home, but seen with a traveller’s eye — two continents, a hundred balloons, one Bosphorus.',
    featured: {
      src: 'https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?auto=format&fit=crop&w=1800&q=80',
      caption: 'Cappadocia at sunrise — silence, then a hundred balloons at once.',
    },
  },
];

// Helper — Unsplash CDN ile boyut belirleyerek URL üret
const u = (id, w, h) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&h=${h}&q=75`;

// Placeholder photo set — gerçek fotolarla değişecek
// width/height ŞART (masonry CLS sıfır olsun diye)
const placeholderPhotos = [
  // Italy
  { id: 'it-1', country: 'italy', city: 'Rome', alt: 'Colosseum exterior arches', src: u('photo-1552832230-c0197dd311b5', 1200, 800), width: 1200, height: 800 },
  { id: 'it-2', country: 'italy', city: 'Rome', alt: 'Trevi fountain detail', src: u('photo-1531572753322-ad063cecc140', 800, 1200), width: 800, height: 1200 },
  { id: 'it-3', country: 'italy', city: 'Florence', alt: 'Florence Duomo from above', src: u('photo-1543429776-2782fc8e1acd', 1200, 800), width: 1200, height: 800 },
  { id: 'it-4', country: 'italy', city: 'Florence', alt: 'Ponte Vecchio at dusk', src: u('photo-1534445867742-43195f401b6c', 800, 1200), width: 800, height: 1200 },
  { id: 'it-5', country: 'italy', city: 'Rome', alt: 'Vatican corridor light', src: u('photo-1525874684015-58379d421a52', 1200, 900), width: 1200, height: 900 },

  // Spain
  { id: 'es-1', country: 'spain', city: 'Barcelona', alt: 'Sagrada Familia facade', src: u('photo-1583422409516-2895a77efded', 800, 1200), width: 800, height: 1200 },
  { id: 'es-2', country: 'spain', city: 'Barcelona', alt: 'Park Güell mosaics', src: u('photo-1539037116277-4db20889f2d4', 1200, 800), width: 1200, height: 800 },
  { id: 'es-3', country: 'spain', city: 'Madrid', alt: 'Plaza Mayor archway', src: u('photo-1543783207-ec64e4d95325', 1200, 800), width: 1200, height: 800 },
  { id: 'es-4', country: 'spain', city: 'Barcelona', alt: 'Gothic Quarter narrow street', src: u('photo-1511527661048-7fe73d85e9a4', 800, 1200), width: 800, height: 1200 },

  // Japan
  { id: 'jp-1', country: 'japan', city: 'Tokyo', alt: 'Shibuya crossing neon', src: u('photo-1542051841857-5f90071e7989', 1200, 800), width: 1200, height: 800 },
  { id: 'jp-2', country: 'japan', city: 'Kyoto', alt: 'Fushimi Inari torii gates', src: u('photo-1493780474015-ba834fd0ce2f', 800, 1200), width: 800, height: 1200 },
  { id: 'jp-3', country: 'japan', city: 'Kyoto', alt: 'Bamboo grove path', src: u('photo-1528164344705-47542687000d', 800, 1200), width: 800, height: 1200 },
  { id: 'jp-4', country: 'japan', city: 'Tokyo', alt: 'Tokyo rooftop skyline', src: u('photo-1503899036084-c55cdd92da26', 1200, 800), width: 1200, height: 800 },
  { id: 'jp-5', country: 'japan', city: 'Osaka', alt: 'Osaka castle reflection', src: u('photo-1590559899731-a382839e5549', 1200, 900), width: 1200, height: 900 },
  { id: 'jp-6', country: 'japan', city: 'Tokyo', alt: 'Ramen counter steam', src: u('photo-1569718212165-3a8278d5f624', 800, 1200), width: 800, height: 1200 },

  // Portugal
  { id: 'pt-1', country: 'portugal', city: 'Lisbon', alt: 'Yellow tram on hill', src: u('photo-1555881400-74d7acaacd8b', 1200, 800), width: 1200, height: 800 },
  { id: 'pt-2', country: 'portugal', city: 'Porto', alt: 'Porto azulejo wall', src: u('photo-1513735492246-483525079686', 800, 1200), width: 800, height: 1200 },
  { id: 'pt-3', country: 'portugal', city: 'Lisbon', alt: 'Alfama district rooftops', src: u('photo-1588535769222-6d63a55727fd', 1200, 800), width: 1200, height: 800 },

  // Greece
  { id: 'gr-1', country: 'greece', city: 'Santorini', alt: 'Oia blue domes', src: u('photo-1533105079780-92b9be482077', 1200, 800), width: 1200, height: 800 },
  { id: 'gr-2', country: 'greece', city: 'Athens', alt: 'Acropolis at golden hour', src: u('photo-1555993539-1732b0258235', 800, 1200), width: 800, height: 1200 },
  { id: 'gr-3', country: 'greece', city: 'Santorini', alt: 'Whitewashed staircase to sea', src: u('photo-1530841377377-3ff06c0ca713', 1200, 800), width: 1200, height: 800 },

  // Morocco
  { id: 'ma-1', country: 'morocco', city: 'Chefchaouen', alt: 'Blue alleyway', src: u('photo-1539020140153-e479b8c5b9c5', 800, 1200), width: 800, height: 1200 },
  { id: 'ma-2', country: 'morocco', city: 'Marrakech', alt: 'Spice market colours', src: u('photo-1597212618440-806262de4f6b', 1200, 800), width: 1200, height: 800 },
  { id: 'ma-3', country: 'morocco', city: 'Marrakech', alt: 'Riad courtyard arches', src: u('photo-1531253450048-e74108d6e8b8', 1200, 900), width: 1200, height: 900 },

  // Türkiye
  { id: 'tr-1', country: 'turkey', city: 'Istanbul', alt: 'Hagia Sophia interior', src: u('photo-1524231757912-21f4fe3a7200', 1200, 800), width: 1200, height: 800 },
  { id: 'tr-2', country: 'turkey', city: 'Cappadocia', alt: 'Hot air balloons sunrise', src: u('photo-1641128324972-af3212f0f6bd', 1200, 800), width: 1200, height: 800 },
  { id: 'tr-3', country: 'turkey', city: 'Istanbul', alt: 'Galata tower at night', src: u('photo-1538430711960-a468950cf45a', 800, 1200), width: 800, height: 1200 },
  { id: 'tr-4', country: 'turkey', city: 'Cappadocia', alt: 'Fairy chimneys landscape', src: u('photo-1570939274717-7eda259b50ed', 1200, 800), width: 1200, height: 800 },
];

// ─── Source-of-truth resolver ───────────────────────────────────────────
// If the manifest has photos (built from real images), use it.
// Otherwise fall back to placeholder data for development.

const manifestHasData =
  Array.isArray(manifest.photos) && manifest.photos.length > 0;

export const countries = manifestHasData
  ? manifest.countries
  : placeholderCountries;

export const photos = manifestHasData ? manifest.photos : placeholderPhotos;

export const isPlaceholderData = !manifestHasData;

export const getCountry = (slug) => countries.find((c) => c.slug === slug);

export const getPhotosByCountry = (slug) =>
  photos.filter((p) => p.country === slug);
